import React, { useState, useEffect } from 'react';
import API from '../library/ApiManager'
import Fnc from '../library/Functions'
import Loader from "react-loader-spinner";

function EmailInp(props) {

  const [loading, setLoading] = useState(null);
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [emailVerified, setEmailVerified] = useState(false);

  //const [, updateState] = React.useState();
  //const forceUpdate = React.useCallback(() => updateState({}), []);

  useEffect(() => {
    // Similar to componentDidMount and componentDidUpdate:

  }, []); //empty array => chiama solo una volta. Senza la chiama ad ogni cambiamento

  function onBlur(e) {
    let val = e.target.value;

    if (props.callbackIsWorking) props.callbackIsWorking();

    if (props.required) {
      //è un campo obbligatorio?

      if (val && val.length > 0) {
        //non ho un valore vuoto

        if (emailVerified !== val) {
          //non è un valore che ho già controllato

          setEmailVerified(null); //resetto valori precedenti

          if (Fnc.validateEmail(val) === Fnc.EnmEmail.OK) {
            //email formalmente valida?

            setLoading(true);

            //-----
            API.verifyEmail(val, (data) => {
              if (data) {
                setEmailVerified(data.email);
                if (data && data.response && data.response.code === 'OK') {
                  setShowError(false);
                  setErrorMsg(null);
                  props.callback(new Fnc.Ret(Fnc.EnmEmail.OK, data.email));
                } else if (data && data.response && data.response.code === 'KO' && data.response.message === 'Email already associated to an existing customer') {
                  setShowError(true);
                  setErrorMsg(Fnc.EnmEmail.NOTFREE.msg);
                  props.callback(new Fnc.Ret(Fnc.EnmEmail.NOTFREE));
                } else {
                  setShowError(true);
                  setErrorMsg(Fnc.EnmEmail.KO.msg);
                  props.callback(new Fnc.Ret(Fnc.EnmEmail.KO));
                }
              } else {
                setEmailVerified(null);
                setShowError(true);
                setErrorMsg(Fnc.EnmEmail.SERVER_DOWN);
                props.callback(new Fnc.Ret(Fnc.EnmEmail.SERVER_DOWN));
              }
              setLoading(false);

            });

          } else {
            setEmailVerified(null);
            setShowError(true);
            setErrorMsg(Fnc.EnmEmail.KO.msg);
            props.callback(new Fnc.Ret(Fnc.EnmEmail.KO));
          }

        }

      } else {
        setShowError(true);
        setErrorMsg(Fnc.EnmEmail.EMPTY.msg);
        props.callback(new Fnc.Ret(Fnc.EnmEmail.EMPTY));
        setEmailVerified(null);
      }
      
    } else {
      setShowError(false);
      setErrorMsg(null);
      props.callback(new Fnc.Ret(Fnc.EnmEmail.OK, null));
    }

  }


  return (
    <>
      <input className={`form-control ${props.isLogged && "disabled"} `} type="email" placeholder="c " disabled={props.isLogged} key={props.email} defaultValue={props.email} onBlur={onBlur}></input>
      <span className={`placeholder-text ${showError && "lblError"} `}>{(props.required ? "* " : "") + "Email"}<Loader visible={loading} className="loadingSpinner" type={Fnc.LoadingInp.TYPE} color={Fnc.LoadingInp.COLOR} height={Fnc.LoadingInp.HEIGHT} width={Fnc.LoadingInp.WIDTH} timeout={Fnc.LoadingInp.TIMEOUT} /></span>
      {showError && <div className="iol-error-label">{errorMsg}</div>}
    </>
  );
}

export default EmailInp;
